import { api } from '../services/axiosConfig';

/** Mirrors `src/data/changelog.ts`. */
export interface ChangelogGroup {
  heading: string;
  bullets: string[];
}

export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  groups: ChangelogGroup[];
}

/** Newest first. Small and static — fetched once per session (WhatsNewDialog
 * and the /whats-new page share the same cached query). */
export const fetchChangelog = () => api.get<ChangelogEntry[]>('/api/changelog').then((r) => r.data);
